export default "/images/9ba55bfd4c526366f001eba52bd45630.avif";